import type { InsightPost } from './types';

export const INSIGHT_V2_PLACEHOLDER_IMAGE = '/images/Cybardplaceholder.png';

function sortPostsByDate(posts: InsightPost[]) {
  return [...posts].sort((left, right) => {
    const leftTime = Date.parse(left.publishedAt) || 0;
    const rightTime = Date.parse(right.publishedAt) || 0;
    return rightTime - leftTime;
  });
}

export function listInsightV2Posts(posts?: InsightPost[] | null) {
  return sortPostsByDate(posts ? [...posts] : []);
}

export function getInsightV2PostBySlug(slug?: string | null, posts?: InsightPost[] | null) {
  if (!slug) return null;
  return listInsightV2Posts(posts).find((post) => post.slug === slug) ?? null;
}

export function getNextInsightV2Post(slug?: string | null, posts?: InsightPost[] | null) {
  const merged = listInsightV2Posts(posts);
  if (!slug || merged.length < 2) return null;
  const currentIndex = merged.findIndex((post) => post.slug === slug);
  if (currentIndex === -1) return null;
  return merged[(currentIndex + 1) % merged.length] ?? null;
}

export function formatInsightPublishedAt(value: string) {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 'Unscheduled';
  return parsed.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
